import { render, staticRenderFns } from "./transferClient.vue?vue&type=template&id=2edfe0ce&"
import script from "./transferClient.vue?vue&type=script&lang=js&"
export * from "./transferClient.vue?vue&type=script&lang=js&"
import style0 from "./transferClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports